import { Link } from 'react-router-dom';
import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import WhatsAppButton from '../../components/feature/WhatsAppButton';
import ScrollToTopButton from '../../components/feature/ScrollToTopButton';
import CookieBanner from '../../components/feature/CookieBanner';

export default function FAQPage() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: '¿Cuánto tiempo tarda el proceso completo de restauración post incendio?',
      answer: 'El tiempo de restauración post incendio en Hospitalet de Llobregat varía según la magnitud de los daños. Un incendio pequeño puede requerir entre 3-7 días para la limpieza de hollín, eliminación de olores y pintura final. Incendios de mayor envergadura pueden necesitar 2-4 semanas, incluyendo desescombro, tratamiento de ozono y pequeñas reparaciones. En RESTAURAX realizamos una evaluación inicial detallada para proporcionarte un calendario preciso. Nuestro equipo trabaja de forma eficiente para minimizar el tiempo de restauración sin comprometer la calidad del resultado final.'
    },
    {
      question: '¿Qué incluye exactamente el servicio de limpieza de hollín?',
      answer: 'Nuestro servicio de limpieza de hollín en Barcelona incluye la eliminación completa de residuos de humo y hollín de todas las superficies afectadas: paredes, techos, suelos, ventanas, puertas y elementos decorativos. Utilizamos productos especializados según el tipo de superficie (pintura, madera, metal, cristal) para no causar daños adicionales. El proceso incluye limpieza en seco para partículas sueltas, limpieza húmeda con detergentes específicos, y tratamiento final con selladores anti-hollín. También limpiamos conductos de ventilación y espacios ocultos donde el hollín puede acumularse. El objetivo es eliminar completamente cualquier rastro visible u oculto de hollín.'
    },
    {
      question: '¿El tratamiento de ozono es seguro para personas y mascotas?',
      answer: 'Sí, el tratamiento de ozono que aplicamos en RESTAURAX es completamente seguro una vez finalizado el proceso. Durante la aplicación del ozono, el espacio debe estar desocupado (sin personas ni mascotas) ya que el ozono en altas concentraciones puede ser irritante. Nuestros técnicos certificados controlan todo el proceso y ventilan adecuadamente el espacio tras el tratamiento. Una vez completado y ventilado (generalmente 2-4 horas después), el ozono se convierte en oxígeno normal y el espacio es totalmente seguro. Este método es ecológico, no deja residuos químicos y es extremadamente efectivo para eliminar olores y desinfectar. Es una de las técnicas más recomendadas para restauración post incendio en Barcelona.'
    },
    {
      question: '¿Proporcionáis presupuestos para compañías de seguros?',
      answer: 'Sí, en RESTAURAX elaboramos presupuestos detallados y completos que puedes presentar a tu compañía de seguros. Incluimos informes exhaustivos de daños, fotografías, presupuestos y toda la documentación técnica necesaria. Sin embargo, es importante aclarar que NO tramitamos ni gestionamos nada directamente con las aseguradoras. Eres tú, como afectado, quien debe presentar la documentación y realizar todas las gestiones con tu compañía de seguros. Nosotros te proporcionamos toda la información necesaria en formato profesional para facilitar tu trámite, pero la relación con la aseguradora es exclusivamente tuya.'
    },
    {
      question: '¿Ofrecéis servicio de emergencia 24 horas?',
      answer: 'Sí, RESTAURAX ofrece servicio de emergencia 24 horas al día, 7 días a la semana, 365 días al año en Hospitalet de Llobregat, Barcelona y toda el área metropolitana. Entendemos que los incendios no respetan horarios y que actuar rápidamente es crucial para minimizar daños. Puedes llamarnos al 690 22 09 44 en cualquier momento y nuestro equipo de guardia responderá inmediatamente. Nos desplazamos rápidamente al lugar del siniestro para realizar una primera evaluación y comenzar con las tareas urgentes de desescombro y limpieza de hollín. La rapidez en la intervención inicial puede marcar una gran diferencia en el resultado final de la restauración post incendio.'
    },
    {
      question: '¿Cómo eliminais completamente los malos olores a humo?',
      answer: 'La eliminación de malos olores tras un incendio requiere un enfoque múltiple que aplicamos en RESTAURAX. Primero, realizamos una limpieza exhaustiva de hollín de todas las superficies, ya que el hollín es la principal fuente de olor. Segundo, limpiamos o eliminamos textiles, alfombras y tapicerías impregnadas. Tercero, aplicamos tratamiento de ozono, que neutraliza las moléculas de olor a nivel molecular. Cuarto, utilizamos selladores especiales en paredes y techos que encapsulan cualquier olor residual. Finalmente, purificamos el aire con filtros HEPA. Este proceso combinado garantiza la eliminación total y permanente de olores a humo en tu propiedad en Barcelona. No utilizamos ambientadores que solo enmascaran el olor, sino técnicas profesionales que lo eliminan definitivamente.'
    },
    {
      question: '¿Qué tipo de pequeñas reparaciones realizáis?',
      answer: 'Nuestro servicio de pequeñas reparaciones en Hospitalet de Llobregat incluye trabajos de albañilería como reparación de grietas, agujeros en paredes y techos, y restauración de yeso dañado. También realizamos trabajos de carpintería: reparación o sustitución de marcos de puertas y ventanas, rodapiés y elementos de madera afectados. Incluimos reparaciones eléctricas básicas como sustitución de enchufes, interruptores y pequeñas reparaciones en el cableado visible. Si es necesario, hacemos arreglos de fontanería menores. También sustituimos elementos como manillas, cerraduras y pequeños accesorios dañados. Para reparaciones estructurales mayores, trabajamos con empresas colaboradoras especializadas. El objetivo es que tu espacio quede completamente restaurado y funcional tras el incendio.'
    },
    {
      question: '¿Proporcionáis presupuesto gratuito antes de comenzar?',
      answer: 'Sí, en RESTAURAX siempre proporcionamos un presupuesto detallado, gratuito y sin compromiso antes de iniciar cualquier trabajo de restauración post incendio en Barcelona. Nuestro equipo se desplaza a tu propiedad en Hospitalet de Llobregat o alrededores para realizar una evaluación exhaustiva de los daños. Documentamos fotográficamente la situación, medimos las áreas afectadas y determinamos qué servicios son necesarios: limpieza de hollín, eliminación de olores, desescombro, tratamiento de ozono, pintura o pequeñas reparaciones. Con esta información, elaboramos un presupuesto desglosado por partidas, especificando materiales, mano de obra y plazos. No hay costes ocultos ni sorpresas. Solo comenzamos a trabajar una vez que has aprobado el presupuesto y estás completamente de acuerdo con las condiciones.'
    }
  ];

  return (
    <>
      {/* Schema.org JSON-LD for FAQ Page */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "name": "Preguntas frecuentes sobre restauración post incendio - RESTAURAX",
          "description": "Resuelve todas tus dudas sobre nuestros servicios de limpieza y restauración post incendio en Hospitalet de Llobregat y Barcelona.",
          "url": `${import.meta.env.VITE_SITE_URL || 'https://restaurax.com'}/faq`,
          "mainEntity": faqs.map(faq => ({
            "@type": "Question",
            "name": faq.question,
            "acceptedAnswer": {
              "@type": "Answer",
              "text": faq.answer
            }
          }))
        })}
      </script>

      <div className="min-h-screen flex flex-col">
        <Header />

        {/* Hero */}
        <section className="bg-gradient-to-br from-[#544E13] to-[#3a3610] text-white py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Preguntas frecuentes</h1>
            <p className="text-xl text-gray-200 max-w-3xl">
              Resuelve todas tus dudas sobre nuestros servicios de limpieza y restauración post incendio en Hospitalet de Llobregat y Barcelona.
            </p>
          </div>
        </section>

        {/* Introducción */}
        <section className="py-16 bg-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-[#544E13] mb-6 text-center">
                Preguntas frecuentes sobre restauración post incendio
              </h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                En <strong>RESTAURAX</strong> entendemos que sufrir un incendio genera muchas dudas e incertidumbres. Por eso hemos recopilado las preguntas más frecuentes que nos hacen nuestros clientes en <strong>Hospitalet de Llobregat</strong> y Barcelona sobre nuestros servicios de <strong>limpieza post incendio</strong>, <strong>eliminación de olores</strong>, <strong>tratamiento de ozono</strong> y restauración completa. Si quieres conocer más sobre <Link to="/empresa" className="text-[#F2D70A] hover:text-[#544E13] font-semibold underline">nuestra empresa y experiencia</Link>, visita nuestra página corporativa.
              </p>
              <p className="text-gray-700 leading-relaxed mb-4">
                A continuación encontrarás respuestas detalladas sobre nuestros procesos de <strong>limpieza de hollín</strong>, <strong>desescombro</strong>, tiempos de ejecución, presupuestos, gestión con seguros y mucho más. Para conocer en detalle todos nuestros <Link to="/servicios" className="text-[#F2D70A] hover:text-[#544E13] font-semibold underline">servicios especializados</Link>, puedes visitar la sección correspondiente. Si tu pregunta no aparece aquí, no dudes en contactarnos directamente al 690 22 09 44 o a través de nuestro <Link to="/contacto" className="text-[#F2D70A] hover:text-[#544E13] font-semibold underline">formulario de contacto</Link>.
              </p>
              <p className="text-gray-700 leading-relaxed">
                Nuestro equipo de profesionales está disponible 24/7 para resolver cualquier duda y ofrecerte el mejor asesoramiento sobre <strong>restauración post incendio en Barcelona</strong>.
              </p>
            </div>
          </div>
        </section>

        {/* FAQ Accordion */}
        <section className="py-16 bg-gray-50">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="space-y-4">
              {faqs.map((faq, index) => (
                <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden">
                  <button
                    onClick={() => setOpenIndex(openIndex === index ? null : index)}
                    className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-50 transition-colors cursor-pointer"
                  >
                    <h3 className="text-lg font-semibold text-[#544E13] mb-2">
                      {faq.question}
                    </h3>
                    <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                      <i className={`${openIndex === index ? 'ri-subtract-line' : 'ri-add-line'} text-2xl text-[#F2D70A]`}></i>
                    </div>
                  </button>
                  {openIndex === index && (
                    <div className="px-6 pb-5">
                      <p className="text-gray-700 leading-relaxed">
                        {faq.answer}
                      </p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Información Adicional */}
        <section className="py-16 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl md:text-4xl font-bold text-[#544E13] mb-12 text-center">
              Información Adicional sobre Nuestros Servicios
            </h2>

            <div className="grid md:grid-cols-2 gap-8 mb-12">
              <div className="bg-gray-50 rounded-lg p-8">
                <div className="w-16 h-16 bg-[#F2D70A] rounded-lg flex items-center justify-center mb-6">
                  <i className="ri-map-pin-line text-3xl text-[#544E13]"></i>
                </div>
                <h3 className="text-xl font-bold text-[#544E13] mb-4">Zona de Cobertura</h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Ofrecemos nuestros servicios de <strong>limpieza y restauración post incendio</strong> en toda el área metropolitana de Barcelona, con especial presencia en Hospitalet de Llobregat, Cornellà, Esplugues, Sant Just Desvern, Sant Feliu, El Prat, Viladecans y Sant Boi.
                </p>
                <p className="text-gray-700 leading-relaxed">
                  Nuestro equipo puede desplazarse rápidamente a cualquier punto de la provincia de Barcelona para atender emergencias post incendio las 24 horas del día.
                </p>
              </div>

              <div className="bg-gray-50 rounded-lg p-8">
                <div className="w-16 h-16 bg-[#F2D70A] rounded-lg flex items-center justify-center mb-6">
                  <i className="ri-shield-check-line text-3xl text-[#544E13]"></i>
                </div>
                <h3 className="text-xl font-bold text-[#544E13] mb-4">Certificaciones y Garantías</h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Todos nuestros técnicos están certificados en <strong>limpieza de hollín</strong>, <strong>tratamiento de ozono</strong> y restauración de espacios dañados. Contamos con seguro de responsabilidad civil y cumplimos con todas las normativas de seguridad y medio ambiente.
                </p>
                <p className="text-gray-700 leading-relaxed">
                  Ofrecemos garantía de satisfacción en todos nuestros trabajos de <strong>restauración post incendio</strong> en Hospitalet de Llobregat y Barcelona.
                </p>
              </div>

              <div className="bg-gray-50 rounded-lg p-8">
                <div className="w-16 h-16 bg-[#F2D70A] rounded-lg flex items-center justify-center mb-6">
                  <i className="ri-money-euro-circle-line text-3xl text-[#544E13]"></i>
                </div>
                <h3 className="text-xl font-bold text-[#544E13] mb-4">Formas de Pago</h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Aceptamos diversas formas de pago para tu comodidad: transferencia bancaria, tarjeta de crédito/débito y efectivo. En caso de trabajar con tu compañía de seguros, gestionamos el pago directamente con ellos.
                </p>
                <p className="text-gray-700 leading-relaxed">
                  Ofrecemos facilidades de pago para proyectos de gran envergadura. Consulta nuestras condiciones sin compromiso.
                </p>
              </div>

              <div className="bg-gray-50 rounded-lg p-8">
                <div className="w-16 h-16 bg-[#F2D70A] rounded-lg flex items-center justify-center mb-6">
                  <i className="ri-customer-service-2-line text-3xl text-[#544E13]"></i>
                </div>
                <h3 className="text-xl font-bold text-[#544E13] mb-4">Atención al Cliente</h3>
                <p className="text-gray-700 leading-relaxed mb-4">
                  Nuestro servicio de atención al cliente está disponible 24/7 para emergencias. Durante el horario comercial (9:00-19:00h) puedes contactarnos para consultas, presupuestos y seguimiento de trabajos en curso.
                </p>
                <p className="text-gray-700 leading-relaxed">
                  Cada cliente tiene asignado un responsable que le mantiene informado del progreso de la <strong>restauración post incendio</strong>.
                </p>
              </div>
            </div>

            <div className="bg-gradient-to-r from-[#F2D70A] to-[#e5ca09] rounded-lg p-8">
              <div className="grid md:grid-cols-2 gap-8 items-center">
                <div>
                  <h3 className="text-2xl font-bold text-[#544E13] mb-4">
                    ¿Tienes Más Preguntas?
                  </h3>
                  <p className="text-[#544E13] leading-relaxed mb-4">
                    Si no has encontrado la respuesta que buscabas sobre nuestros servicios de <strong>limpieza post incendio</strong>, <strong>eliminación de olores</strong> o <strong>tratamiento de ozono</strong> en Hospitalet de Llobregat, no dudes en contactarnos. También puedes conocer más sobre <Link to="/empresa" className="text-[#544E13] hover:text-white font-bold underline">nuestra empresa</Link> o revisar todos nuestros <Link to="/servicios" className="text-[#544E13] hover:text-white font-bold underline">servicios especializados</Link>.
                  </p>
                  <p className="text-[#544E13] leading-relaxed">
                    Nuestro equipo de expertos estará encantado de resolver todas tus dudas y ofrecerte el mejor asesoramiento personalizado para tu caso específico.
                  </p>
                </div>
                <div className="flex flex-col space-y-4">
                  <Link 
                    to="/contacto"
                    className="bg-[#544E13] text-white px-8 py-4 rounded-lg font-bold text-center hover:bg-white hover:text-[#544E13] transition-all whitespace-nowrap cursor-pointer"
                  >
                    Formulario de Contacto
                  </Link>
                  <a 
                    href="tel:690220944"
                    className="bg-white text-[#544E13] px-8 py-4 rounded-lg font-bold text-center hover:bg-[#544E13] hover:text-white transition-all whitespace-nowrap cursor-pointer"
                  >
                    <i className="ri-phone-line mr-2"></i>
                    Llamar: 690 22 09 44
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Consejos Útiles */}
        <section className="py-16 bg-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h2 className="text-3xl md:text-4xl font-bold text-[#544E13] mb-12 text-center">
              Consejos útiles post incendio
            </h2>
            <p className="text-xl text-gray-600 text-center mb-12 max-w-3xl mx-auto">
              Recomendaciones importantes de nuestros expertos en <strong>restauración post incendio</strong> en Barcelona.
            </p>

            <div className="grid md:grid-cols-3 gap-8">
              <div className="bg-white rounded-lg p-6 shadow-lg">
                <div className="w-12 h-12 bg-[#F2D70A] rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-alert-line text-2xl text-[#544E13]"></i>
                </div>
                <h3 className="text-xl font-bold text-[#544E13] mb-3">No toques nada</h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Evita tocar superficies con hollín sin protección. El hollín puede ser tóxico y manchar permanentemente. Espera a que lleguen los profesionales de RESTAURAX.
                </p>
              </div>

              <div className="bg-white rounded-lg p-6 shadow-lg">
                <div className="w-12 h-12 bg-[#F2D70A] rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-camera-line text-2xl text-[#544E13]"></i>
                </div>
                <h3 className="text-xl font-bold text-[#544E13] mb-3">Documenta los daños</h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Toma fotografías de todos los daños antes de mover nada. Esta documentación será importante para el seguro y para planificar la restauración.
                </p>
              </div>

              <div className="bg-white rounded-lg p-6 shadow-lg">
                <div className="w-12 h-12 bg-[#F2D70A] rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-time-line text-2xl text-[#544E13]"></i>
                </div>
                <h3 className="text-xl font-bold text-[#544E13] mb-3">Actúa rápido</h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Cuanto antes comience la limpieza de hollín y eliminación de olores, mejores serán los resultados. Contacta con RESTAURAX inmediatamente.
                </p>
              </div>

              <div className="bg-white rounded-lg p-6 shadow-lg">
                <div className="w-12 h-12 bg-[#F2D70A] rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-wind-line text-2xl text-[#544E13]"></i>
                </div>
                <h3 className="text-xl font-bold text-[#544E13] mb-3">Ventila el espacio</h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Si es seguro hacerlo, abre ventanas para ventilar. Esto ayuda a reducir la concentración de humo y olores mientras llega nuestro equipo.
                </p>
              </div>

              <div className="bg-white rounded-lg p-6 shadow-lg">
                <div className="w-12 h-12 bg-[#F2D70A] rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-phone-line text-2xl text-[#544E13]"></i>
                </div>
                <h3 className="text-xl font-bold text-[#544E13] mb-3">Contacta con profesionales</h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  Informa a tu compañía de seguros lo antes posible. RESTAURAX puede ayudarte con toda la gestión y documentación necesaria.
                </p>
              </div>

              <div className="bg-white rounded-lg p-6 shadow-lg">
                <div className="w-12 h-12 bg-[#F2D70A] rounded-lg flex items-center justify-center mb-4">
                  <i className="ri-shield-check-line text-2xl text-[#544E13]"></i>
                </div>
                <h3 className="text-xl font-bold text-[#544E13] mb-3">Seguridad primero</h3>
                <p className="text-gray-600 text-sm leading-relaxed">
                  La restauración post incendio requiere conocimientos especializados. No intentes hacerlo tú mismo, confía en expertos como RESTAURAX.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-16 bg-gradient-to-br from-[#544E13] to-[#3a3610] text-white">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl md:text-4xl font-bold mb-6">
              ¿Tienes más preguntas? Contacta con nosotros
            </h2>
            <p className="text-xl mb-8 text-gray-200">
              No esperes más. Contacta con RESTAURAX y comienza la recuperación de tu espacio en Hospitalet de Llobregat. Estamos disponibles 24/7 para emergencias.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link 
                to="/contacto"
                className="bg-[#F2D70A] text-[#544E13] px-8 py-4 rounded-lg font-bold text-lg hover:bg-white transition-all whitespace-nowrap cursor-pointer"
              >
                Solicitar Presupuesto Gratis
              </Link>
              <a 
                href="tel:690220944"
                className="bg-white/10 backdrop-blur-sm text-white border-2 border-white px-8 py-4 rounded-lg font-bold text-lg hover:bg-white hover:text-[#544E13] transition-all whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line mr-2"></i>
                690 22 09 44
              </a>
            </div>
          </div>
        </section>

        <Footer />
        <WhatsAppButton />
        <ScrollToTopButton />
      </div>
    </>
  );
}